import React, { useRef } from 'react';

import profile from './placeholder.jpg';
import appStoreLogo from './apple_store.png';

import Flipping from './Flipping.js';
import KnightsTour from './KnightsTour.js';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

var lightMode = false;

function toggleMode() {
    var element = document.body;
    lightMode = !lightMode;
    element.classList.toggle("light-mode");
}

function Home() {
    return (
        <div class="main-container">
            <div class="content-container">
                {/* name and picture, description (dev, designer, enthusiast) */}
                <div> {/* TITLE AREA */}
                    <div class="title-container">
                        <h1>Mitch Norris</h1>
                        <p>Fullstack (Dev, Designer, Enthusiast)</p>
                    </div>
                    <div class="title-container" style={{ marginLeft: 30 }}>
                        <div class="poligon">
                            <img src={profile} width={140} height={140} alt="Headshot of Mitch Norris" />
                        </div>
                    </div>
                </div>
                {/* work tab describing my past work */}
                <div class="body-container"> {/* WORK AREA */}
                    <h3>Work</h3>
                    <p>I am a fullstack software developer, with my latest experience being in frontend hybrid mobile applications.
                        I have a passion for frontend work, UX/UI design and implementation, and finding elegant solutions to tricky problems
                        in the codespace. With experience across the entire development cycle in professional
                        environments, I always ready for new challenges, wherever they may lie in the development stack. When I'm not
                        working, I enjoy tinkering with 3D printing, cooking, gaming, or walking my dog.
                    </p>
                    <div class="projects-button">
                        <Link to="/projects">My Work</Link>
                    </div>
                </div>
                <div class="bio-container"> {/* BIO AREA */}
                    <h3>Life</h3>
                    <div class="timeline-div"> <span>1997</span>Born in Ottawa, Ontario</div>
                    <div class="timeline-div"> <span>2020</span>Complete the Computer Programmer program at Algonquin College with Honours</div>
                    <div class="timeline-div"> <span>2020</span>Begun working full time at Telepin Software Systems, ultimately working as a Lead Modile Developer</div>
                    <div class="timeline-div"> <span>2026</span>Heading into the next chapter of my career</div>
                </div>
                <div class="find-me-container"> {/* ABOUT AREA */}
                    <h3>Where to Find Me</h3>
                    <div class="projects-button">
                        <Link to="/about">Online</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

function About() {
    return (
        <div class="main-container">
            <div class="content-container">
                <h2 class="about-label">Fullstack Developer</h2>

                <div class="body-container">
                    <h3>My Interests</h3>
                    <p>
                        I enjoy 3D printing, gaming, cooking, baking, astronomy, watching streams, music
                    </p>
                </div>

                <ul role="list" class="about-list about-page">
                    <li>
                        <a target="_blank" class="about-anchor" href="https://github.com/mitchn5">
                            <button type="button" class="about-button">
                                <span class="about-span"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9a17.56 17.56 0 003.8.4c8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1a102.4 102.4 0 01-22.6 2.7c-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1a63 63 0 0025.6-6c2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8a18.64 18.64 0 015-.5c8.1 0 26.4 3.1 56.6 24.1a208.21 208.21 0 01112.2 0c30.2-21 48.5-24.1 56.6-24.1a18.64 18.64 0 015 .5c12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5a19.35 19.35 0 004-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z"></path></svg>
                                </span>@mitchn5
                            </button>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" class="about-anchor" href="https://www.linkedin.com/in/michaelrnorris/">
                            <button type="button" class="about-button">
                                <span class="about-span"><svg stroke="currentColor" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
                                </span>@michaelrnorris
                            </button>
                        </a>
                    </li>
                    {/* <li>
                        <a target="_blank" class="about-anchor" href="https://twitter.com/michaelnlegit">
                            <button type="button" class="about-button">
                                <span class="about-span"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M496 109.5a201.8 201.8 0 01-56.55 15.3 97.51 97.51 0 0043.33-53.6 197.74 197.74 0 01-62.56 23.5A99.14 99.14 0 00348.31 64c-54.42 0-98.46 43.4-98.46 96.9a93.21 93.21 0 002.54 22.1 280.7 280.7 0 01-203-101.3A95.69 95.69 0 0036 130.4c0 33.6 17.53 63.3 44 80.7A97.5 97.5 0 0135.22 199v1.2c0 47 34 86.1 79 95a100.76 100.76 0 01-25.94 3.4 94.38 94.38 0 01-18.51-1.8c12.51 38.5 48.92 66.5 92.05 67.3A199.59 199.59 0 0139.5 405.6a203 203 0 01-23.5-1.4A278.68 278.68 0 00166.74 448c181.36 0 280.44-147.7 280.44-275.8 0-4.2-.11-8.4-.31-12.5A198.48 198.48 0 00496 109.5z"></path></svg>
                                </span>@michaelnlegit
                            </button>
                        </a>
                    </li> */}
                    <li>
                        <a target="_blank" class="about-anchor" href="https://www.instagram.com/michael.r.norris/">
                            <button type="button" class="about-button">
                                <span class="about-span"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"></path><path d="M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z"></path></svg>
                                </span>@michael.r.norris
                            </button>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
}

function Projects() {
    const tourRef = useRef(null);
    const handleReset = () => {
        if (tourRef.current) {
            // Direct method invocation down the ref channel safely bypassing p5 loops
            tourRef.current.triggerReset();
        }
    };

    return (
        <div class="main-container">
            <div class="content-container">
                <h2 class="projects-label">My Work</h2>
                <div class="projects-container">
                    <h3>Flipping</h3>
                    <h5>Coin Flipping Hybrid Mobile App</h5>
                    <div class="canvas-container">
                        <Flipping />
                    </div>
                    <p>
                        Flipping is a mobile app developed using React and threeJS as the physics library I
                        deployed to the App Store and tested on the Google Play Store. This was great practice
                        in using new JS frameworks, going greatly with my professional experience with Angular
                        and Typescript.
                    </p>
                    <div class="app-store-div">
                        <a href='https://apps.apple.com/ca/app/flipping/id6754335720'>
                            <button type="button" class='app-store-button'>
                                <img src={appStoreLogo} style={{ width: 130 }} />
                            </button>
                        </a>
                    </div>
                </div>
                <div class="projects-container">
                    <h3>I'm making a game!</h3>
                    <h5>Brick Breaker Roguelike in Godot</h5>
                    <div style={{ height: '25vh'}}>
                        <iframe
                            src="/game/GodotBreaker.html"
                            title="Godot Game"
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                        />
                    </div>
                    <p style={{ marginTop: 20 }}>
                        I am in the throws of learning Godot 4, and learning the ins and outs of the game development process.
                        This will (hopefully) be a roguelike brick breaker game, with multiple block types, random level generation,
                        and card based scoring multipliers / gameplay modifiers.
                    </p>
                </div>
                <div class="projects-container">
                    <h3>Knight's Tour</h3>
                    <h5>Interactive Visualization</h5>
                    <div className="canvas-container">
                        {/* Pass the communication ref straight into the child component */}
                        <KnightsTour ref={tourRef} />
                        <button type="button" class='tour-button'
                            onClick={handleReset}>
                            Reset Board
                        </button>
                    </div>

                    <p style={{ marginTop: 20 }}>
                        A problem I've always found intriguing and never got around to implementing, until now.
                        This classic chess problem is implemented above using p5JS, with the backtracking algorithm.
                    </p>
                </div>
                {/* <div class="projects-container">
                    <h3>Jellyfin</h3>
                    <h5>Self Hosted Media Server</h5>
                    <img class="jellyfin" />
                    <p>
                        Jellyfin is a self hosted media server. It is running in a Docker container
                        in my homelab. Movies are added from DVDs I've aquired and burned over time. With this
                        jellyfin instance I'm able to stream my media anywhere I am. It helped me gain more
                        knowledge of how docker works, as well as networking principles.
                    </p>
                </div> */}
                <div class="projects-container">
                    <h3>Personal Website</h3>
                    <h5>Self Deployed and Designed ReactJS Website</h5>
                    <p>
                        In need of some sort of landing page for my work and skillset, I've built this website.
                        Using ReactJS as a framework I've built this small website to handle desktop and
                        mobile experiences while maintaining a similar feel. Always looking to improve my design
                        and implementation skills, this project was both fun and vital.
                    </p>
                </div>
            </div>
        </div>
        //small window with con flipper
        // coin flip app descrption with ios download link
        // jellyfin icon with desc on how I did and maintain it
    );
}

function App() {
    return (
        <Router>
            <div class="topnav">
                <Link to="/"><h3 class="nametag">Mitch Norris</h3></Link>
                {window.innerWidth > 500 ?
                    <div>
                        <Link to="/projects">Projects</Link>
                        <Link to="/about">About</Link>
                    </div>
                    : null
                }
                <label class="switch">
                    <input type="checkbox" onClick={toggleMode} />
                    <span class="slider round"></span>
                </label>
            </div>
            <div>
                <Routes>
                    <Route path="/about" element={<About />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/" element={<Home />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
